import { useAppSelector } from "../../../../../store/reduxHooks";
import { SELECT_REQUEST_BANK_ID } from "../../../../../store/selectors/requestAppSelector";

export const useCommisionFields = () => {
  const data = useAppSelector(SELECT_REQUEST_BANK_ID);
  const bankRate = data?.bank_rate ? data?.bank_rate : data?.bank?.base_rate;

  const info = {
    overstatement: data.overstatement ? +data.overstatement : 0,
    base_commission: +data.base_commission,
    bank_commission: data.overstatement
      ? +data.overstatement + +data.base_commission
      : data.base_commission,
  };
  return [
    { name: "Тариф банка", value: `${info.base_commission} ₽` },
    { name: "Ставка", value: `${bankRate}` },
    { name: "Завышение", value: `${info.overstatement} ₽` },
    { name: "Итоговая комиссия", value: `${info.bank_commission} ₽` },
  ];
};
